const state = {
    token:'',
    userInfo:{},
    isMobile:false,
    drawer:false,
    children: [],
    ShedId: 0,
    shedPath: '',
    loginPath: '/',
    categoryId: 0, //栏目ID
    NavList: [] //菜单
  };
  const getters = {   //实时监听state值的变化(最新状态)
    token(state){
      return state.token
    },
    userInfo(state) {
      return state.userInfo
    },
    isMobile(state) {
      return state.isMobile
    },
    drawer(state) {
      return state.drawer
    },
    children(state) {
      return state.children
    },
    ShedId(state) {
      return state.ShedId
    },
    shedPath(state) {
      return state.shedPath
    },
    loginPath(state) {
      return state.loginPath
    },
    categoryId(state) {
      return state.categoryId
    },
    NavList(state) {
      return state.NavList
    },
  };
  
  const mutations = {
    save_token(state,data){
      state.token = data
    },
    save_user_info(state,data){
      state.userInfo = data
    },
    clear_user_info(state){
      state.token = '';
      state.userInfo = {};
    },
    save_ismobile(state,data){
      state.isMobile = data
    },
    save_drawer(state,data){
      state.drawer = data
    },
    save_children(state,data){
      state.children = data
    },
    save_shedId(state,data){
      state.ShedId = data
    },
    save_shedPath(state,data){
      state.shedPath = data
    },
    save_loginPath(state,data){
      state.loginPath = data
    },
    save_categoryId(state,data){
      state.categoryId = data
    },
    save_NavList(state,data){
      state.NavList = data
    }
  }
  
  const actions={
    saveToken(context,data){
      context.commit('save_token',data);
    },
    saveUserInfo(context,data){
      context.commit('save_user_info',data);
    },
    clearUserInfo(context){
      context.commit('clear_user_info');
    },
    saveIsMobile(context,data){
      context.commit('save_ismobile',data);
    },
    saveIsDrawer(context,data){
      context.commit('save_drawer',data);
    },
    saveChildren(context,data){
      context.commit('save_children',data);
    },
    saveShedId(context,data){
      context.commit('save_shedId',data);
    },
    saveShedPath(context,data){
      context.commit('save_shedPath',data);
    },
    saveLoginPath(context,data){
      context.commit('save_loginPath',data);
    },
    saveCategoryId(context,data){
      context.commit('save_categoryId',data);
    },
    saveNavList(context,data){
      context.commit('save_NavList',data);
    },
  };
  
  export default {
    namespaced:true,//用于在全局引用此文件里的方法时标识这一个的文件名
    state,
    getters,
    mutations,
    actions
  }


// WEBPACK FOOTER //
// ./src/store/modules/user.js